import { importComponents } from '~/helpers'
import ValidationService from 'services/ValidationService'

export default {
    components: {
        ...importComponents(require.context('components/form-inputs')),
        ...importComponents(require.context('components/form-elements')),
    },

    data() {
        return {
            data: {
                errors: {},
            },
            isLoading: false,
        }
    },

    methods: {
        setValue(path, value) {
            this.data[path] = value
            this.data.errors = {}
        },

        setErrors(errors) {
            ValidationService.clear()
            errors.forEach(({ path, value }) => {
                this.data.errors[path] = value
            })
        },

        change({ path, value }) {
            if (value !== undefined) {
                if (value === 0) {
                    return this.setValue(path, value)
                }
                if (!value) {
                    return this.setValue(path, undefined)
                }
                this.setValue(path, value)
            }
        },

        clear({ path }) {
            delete this.data[path]
        },

        prefillData(data) {
            for (let [path, value] of Object.entries(data)) {
                this.setValue(path, value)
            }
        },

        submitForm(api, configuration) {
            ValidationService.clear()
            this.isLoading = true
            this.$startLoader()
            return api
                .then((data) => {
                    this.emitEvent({ name: 'success' })
                    if (configuration?.scrollTop) {
                        window.scrollTo(0, 0)
                    }
                    return data
                })
                .finally((data) => {
                    this.isLoading = false
                    this.$stopLoader()
                    setTimeout(() => {
                        this.triggerAutoScrollError()
                    }, 0)
                    return data
                })
        },

        triggerAutoScrollError() {
            const errorsInput = document.querySelectorAll('.form-input-text--error')
            if (errorsInput && errorsInput[0].previousElementSibling) {
                errorsInput[0].previousElementSibling.scrollIntoView({
                    behavior: 'auto',
                    block: 'center',
                    inline: 'center',
                })
            }
        },
    },

    beforeUnmount() {
        ValidationService.clear()
    },
}
